import { ComponentOptions } from 'vue';
import Store from '@/store';
import { activityService } from '@/services/v2/ActivityService';

export const ActivityMixin: ComponentOptions = {
  computed: {
    lastActiveDate(): Date | undefined {
      return Store.state.lastActiveDate;
    }
  },
  watch: {
    async lastActiveDate(newVal, oldVal) {
      if (newVal !== oldVal) {
        await activityService.setUserLastActive();
      }
    }
  }
};